import { getNicheMeta, normalizeNicheKey } from "./nicheMeta";

/** Illustrated stroke icons with subtle fill accents — one per niche. */
const NICHE_ICON_MAP = {
  wellness: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M12 21c-4.5-3.5-7.5-7.2-7.5-11.2C4.5 6.5 7.8 3 12 3s7.5 3.5 7.5 6.8C19.5 13.8 16.5 17.5 12 21z"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M12 21V9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path
        d="M9 13c1.2-1.5 2.5-2.2 3-2.2s1.8.7 3 2.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="15.5" cy="8" r="1" fill="currentColor" fillOpacity="0.55" stroke="none" />
    </svg>
  ),
  beauty: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle
        cx="10"
        cy="10"
        r="5.5"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path d="M15.2 14.8L19 18.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M12 3.5l.9 2.7 2.8 1-2.8 1L12 10.9l-.9-2.7-2.8-1 2.8-1L12 3.5z"
        fill="currentColor"
        fillOpacity="0.35"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 19.5l1.4-1.4M17.5 6.5l-1.4 1.4"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.7"
      />
    </svg>
  ),
  food: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M5 14h14l-1.2 4.5a1 1 0 01-.96.7H7.16a1 1 0 01-.96-.7L5 14z"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <ellipse cx="12" cy="14" rx="7" ry="1.2" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8 5c0 2.5 1.2 4 2 4M16 5c0 2.5-1.2 4-2 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M10 5V3M14 5V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M9 8.5c.8.8 1.7 1.2 3 1.2s2.2-.4 3-1.2"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.65"
      />
    </svg>
  ),
  fitness: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect
        x="3"
        y="9"
        width="3.5"
        height="6"
        rx="1.2"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="17.5"
        y="9"
        width="3.5"
        height="6"
        rx="1.2"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M6.5 10.5h11M6.5 13.5h11" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path
        d="M12 6.5v2M12 15.5v2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.55"
      />
      <path d="M4 12h2M18 12h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  auto: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M4.5 12.5l1.8-5.2a1.2 1.2 0 011.1-.8h9.2a1.2 1.2 0 011.1.8l1.8 5.2"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M4 12.5h16v3.5H4z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M8 10h8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
      <circle
        cx="7.5"
        cy="16"
        r="1.6"
        fill="currentColor"
        fillOpacity="0.25"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <circle
        cx="16.5"
        cy="16"
        r="1.6"
        fill="currentColor"
        fillOpacity="0.25"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M19.5 14.5l1.5-1M4.5 14.5l-1.5-1"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        opacity="0.45"
      />
    </svg>
  ),
  mind: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M6 8.5c0-2.2 2.7-4 6-4s6 1.8 6 4v8.5H6V8.5z"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M12 4.5v13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.35" />
      <path d="M8.5 10h7M8.5 13h5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.55" />
      <path
        d="M14.5 4l1.2 2.2 2.4.4-1.7 1.7.4 2.4-2.3-1.2-2.3 1.2.4-2.4-1.7-1.7 2.4-.4L14.5 4z"
        fill="currentColor"
        fillOpacity="0.3"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arts: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M12 3c-3.5 0-6 2.2-6 5.2 0 2.2 1.4 4 3.5 4.8-.4.9-.6 1.8-.6 2.7 0 .8.6 1.5 1.4 1.5h3.4c.8 0 1.4-.7 1.4-1.5 0-.9-.2-1.8-.6-2.7 2.1-.8 3.5-2.6 3.5-4.8C18 5.2 15.5 3 12 3z"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="7.5" r="1.1" fill="#E85D75" stroke="none" />
      <circle cx="12" cy="6.5" r="1.1" fill="#C4790A" stroke="none" />
      <circle cx="15" cy="7.5" r="1.1" fill="#6B4FA8" stroke="none" />
      <path d="M8.5 18.5h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
    </svg>
  ),
  independent: (props) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M12 2.5l2.1 6.5H21l-5.4 3.9 2.1 6.5L12 16.5 6.2 19.4l2.1-6.5L3 9h6.9L12 2.5z"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="2" fill="currentColor" fillOpacity="0.35" stroke="none" />
    </svg>
  ),
};

const SIZE_PRESETS = {
  xs: 11,
  sm: 14,
  md: 22,
  lg: 28,
};

/**
 * @param {{ niche: string | string[] | undefined, size?: number | keyof typeof SIZE_PRESETS, className?: string }} props
 */
export function NicheIcon({ niche, size = "md", className, ...props }) {
  const key = normalizeNicheKey(niche);
  const Icon = NICHE_ICON_MAP[key] || NICHE_ICON_MAP.independent;
  const px = typeof size === "number" ? size : SIZE_PRESETS[size] ?? SIZE_PRESETS.md;

  return (
    <span className={`niche-icon niche-icon--${key}${className ? ` ${className}` : ""}`} aria-hidden="true">
      <Icon width={px} height={px} {...props} />
    </span>
  );
}

/**
 * Pill badge with icon + label.
 * @param {{ niche: string | string[] | undefined, label?: string, className?: string, iconSize?: number | keyof typeof SIZE_PRESETS, showIcon?: boolean }} props
 */
export function NicheBadge({ niche, label, className = "", iconSize = "xs", showIcon = true }) {
  const meta = getNicheMeta(niche);

  return (
    <span className={`niche-badge ${meta.badgeClass}${className ? ` ${className}` : ""}`}>
      {showIcon && <NicheIcon niche={meta.key} size={iconSize} className="niche-badge__icon" />}
      <span>{label ?? meta.label}</span>
    </span>
  );
}

/**
 * Inline icon + label for secondary text rows.
 */
export function NicheInline({ niche, label, className = "", iconSize = "sm", suffix }) {
  const meta = getNicheMeta(niche);

  return (
    <span className={`niche-inline${className ? ` ${className}` : ""}`}>
      <NicheIcon niche={meta.key} size={iconSize} />
      <span>{label ?? meta.label}</span>
      {suffix != null && <span>{suffix}</span>}
    </span>
  );
}

export { NICHE_ICON_MAP };
